import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Home from '../containers/home/Home';
import Error404 from '../containers/Error404';
import localDB from "../data/localDB";
import DeliveryHome from "../containers/home/DeliveryHome";
import RepairShopHome from "../containers/home/RepairShopHome";

class HomeRoute extends Component {

    render() {
        console.log(localDB.get('user').rol)
        let home_component = ''
        if(localDB.get('user').rol === 'R'){
            home_component = DeliveryHome
        }else if(localDB.get('user').rol === 'technical'){
            home_component = RepairShopHome
        }else{
            home_component = Home
        }
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/' component={home_component}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default HomeRoute;



// WEBPACK FOOTER //
// ./src/routes/HomeRoute.js